import React from "react";
import PropTypes from "prop-types";
import style from "./style.module.scss";
import { StreakList } from "./StreakList";
import { LongestStreakPlayer } from "./LongStreakPlayer";
import { ACTION, StreakReducer, INITIAL_STATE } from "./StreakCounter.utils";

/**
 * StreakCounter:
 *  - Component display number of successive steps completed
 *  - Animates when previous streak is broken
 */
export function StreakCounter(props) {
  const [state, dispatch] = React.useReducer(StreakReducer, INITIAL_STATE);

  React.useEffect(() => {
    dispatch({
      type: ACTION.SET_NEW_STREAK,
      payload: props,
    });
  }, [props.currentStreak]);

  const onUpdateUnitStreakStatus = (payload) => {
    dispatch({
      type: ACTION.UPDATE_UNIT_STREAK_STATE,
      payload,
    });
  };

  const onUpdateLongestStreakStatus = (payload) => {
    dispatch({
      type: ACTION.UPDATE_LONGEST_STREAK_STATE,
      payload,
    });
  };

  const className = `${style.streak} ${props.className}`;

  return (
    <div className={className}>
      <div className={style.streak_block}>
        <h5 className={style.title}>STREAK COUNTER</h5>
        <StreakList
          streakUnits={state.unitStreaks}
          updateStatus={onUpdateUnitStreakStatus}
        />
      </div>
      <div className={style.streak_total}>
        <span className={style.totalText}>{props.longestStreak}</span>
        <LongestStreakPlayer
          className={style.totalIcon}
          state={state.longestStreak}
          playComplete={onUpdateLongestStreakStatus}
        />
      </div>
    </div>
  );
}

StreakCounter.propTypes = {
  /**
   * ClassName
   */
  className: PropTypes.string,
  /**
   * Latest streak count
   */
  currentStreak: PropTypes.number,
  /**
   * Longest Streak count
   */
  longestStreak: PropTypes.number,
  /**
   * Boolean set if latest operation is success
   */
  isLatestOperationCorrect: PropTypes.bool,
};

StreakCounter.defaultProps = {
  className: "",
  currentStreak: 0,
  longestStreak: 0,
  isLatestOperationCorrect: false,
};
